<template>
<div>
  <div class="popBg" @click="closeSubscribe"></div>
  <div class="popup fixed">
    <div class="popup__inner fixed z-40 pt-5 pb-5 px-4 md:px-10 bg-white max-w-xs md:max-w-md rounded" v-if="hasID">
      <div class="toggle flex justify-end mb-5">
        <a class="text-sm textColorDarkBlack cursor-pointer text-NotoSansRegular underline" @click="hasID = false">使用訂戶資料查詢</a>
      </div>
      <div class="popup__header text-NotoSansRegular textColorRed text-base mb-5 flex justify-center">
        <h6>輸入訂戶編號查詢</h6>
      </div>
      <div class="popup__body text-NotoSansRegular text-base mb-4">
        <div class="md:flex">
          <div class="md:w-1/3">
            <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular text-sm" for="SubscriberID">
              訂戶編號：
            </label>
          </div>
          <div class="md:w-2/3">
            <input class="text-sm appearance-none border-2 rounded w-full py-2 px-4 leading-tight focus:outline-none"
              id="SubscriberID" type="text" value="" v-model.trim="subscriberID" maxlength="8" placeholder="請輸入後8碼數字">
              <span class="text-xs textColorRed opacity-0" :class="{ showError: isSubscriberIDverify === false }">查無訂戶編號</span>
          </div>
        </div>
      </div>
      <div class="popup__buttons flex justify-center">
        <a class="px-10 py-3 textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
          @click.prevent="submit">
          送出
          <font-awesome-icon icon="circle-notch" spin v-if="isLoading" />
        </a>
      </div>
    </div>
    <div class="popup__inner fixed z-40 pt-5 pb-5 px-4 md:px-10 bg-white max-w-xs md:max-w-md rounded-lg" v-if="!hasID">
      <div class="toggle flex justify-end mb-5">
        <a class="text-sm textColorDarkBlack cursor-pointer text-NotoSansRegular underline" @click="hasID = true">已有訂戶編號</a>
      </div>
      <div class="popup__header text-NotoSansRegular textColorRed text-base mb-5 flex justify-center">
        <h6>輸入訂戶資料查詢</h6>
      </div>
      <div class="popup__body text-NotoSansRegular text-base mb-4">
        <div class="md:flex md:items-start md:flex-wrap">
          <div class="md:w-1/3 h-full md:mb-2">
            <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular text-sm" for="name">
              姓名：
            </label>
          </div>
          <div class="md:w-2/3 flex flex-col justify-center items-end mb-2">
            <input class="text-sm appearance-none border-2 rounded w-full py-2 px-4 leading-tight focus:outline-none"
              id="name" type="text" value="" v-model.trim="name">
          </div>
          <div class="md:w-1/3 h-full">
            <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4 text-NotoSansRegular text-sm" for="email">
              E-mail：
            </label>
          </div>
          <div class="md:w-2/3 flex flex-col justify-center items-end">
            <input class="text-sm appearance-none border-2 rounded w-full py-2 px-4 leading-tight focus:outline-none"
              id="email" type="email" value="" v-model.trim="email">
              <span class="text-xs textColorRed opacity-0" :class="{ showError: isSubscriberIDcheck === false }">查無訂戶編號</span>
          </div>
        </div>
      </div>
      <div class="popup__buttons flex justify-center">
        <a class="px-10 py-3 textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
          @click.prevent="Inquire">
          查詢<font-awesome-icon icon="circle-notch" spin v-if="isLoading" />
        </a>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SubscriberID',

  data () {
    return {
      // 切換
      hasID: true,
      isLoading: false,

      // input訂戶編號
      subscriberID: null,
      isSubscriberIDverify: null,

      // input查詢訂戶編號
      name: null,
      email: null,
      isSubscriberIDcheck: null
    }
  },

  props: {
  },

  methods: {
    closeSubscribe () {
      let self = this
      self.$emit('closeSubscribe', false)
    },
    async submit () {
      // 驗證訂戶編號
      let self = this
      if (self.subscriberID && self.subscriberID.length === 8) {
        self.isLoading = true
        await axios.post('/check-subscriber', {
          'cust_id': self.subscriberID
        })
          .then((response) => {
            if (response.data.status === true) {
              localStorage.setItem('sId', self.subscriberID.trim())
              self.$emit('closeSubscribe', false)
              self.$emit('verifySubscribe', true)
              self.isLoading = false
            } else {
              self.isSubscriberIDverify = false
              self.isLoading = false
              self.subscriberID = null
            }
          })
      }
    },
    async Inquire () {
      // 查詢訂戶編號
      let self = this
      if (self.email && self.name) {
        self.isLoading = true
        await axios.post('/check-subscriber-id', {
          'cust_name': self.name,
          'email': self.email
        })
          .then((response) => {
            if (response.data.status === true) {
              localStorage.setItem('sId', response.data.cust_id)
              self.$emit('closeSubscribe', false)
              self.$emit('verifySubscribe', true)
              self.isLoading = false
            } else {
              self.isSubscriberIDcheck = false
              self.isLoading = false
              self.name = null
              self.email = null
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 45%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      font-weight: bold;
    }
    .popup__buttons {
          text-align: right;
      .btn--small {
          line-height: 22px;
      }
      .btn {
        display: inline-block;
        font-size: 11px;
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        height: auto;
        line-height: 1;
        background-color: white;
        border: 1px solid #9c9c9c;
        color: #434343;
        white-space: nowrap;
        transition: .3s;
        border-radius: 5px;
        &:hover {
          border: 1px solid #a0a0a0;
          background: #9c9c9c !important;
          color: white;
        }
      }
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

  @keyframes example {
    from {
      opacity: 0;
      margin-top: -77px;
      transform: scale(1);
    }
    to {
      opacity: 1;
      margin-top: -77px;
      transform: scale(1);
      }
  }
</style>
